import TaskRunner from '../base/TaskRunner';
import FileInput from '../components/FileInput';
import FieldMasker from '../components/FieldMasker';
import FieldValidation from '../components/FieldValidation';
import LiveEvent from '../base/LiveEvent';
import DatePicker from '../components/DatePicker';
import FieldFormatter from '../components/FieldFormatter';
import axios from "axios";

TaskRunner.add(() => {
    const initFld = function(inp){
        switch (inp.type) {
            case 'file':
                new FileInput(inp);
                break;
        }

        const validator = inp.getAttribute('data-validation');

        if (validator != null) {
            new FieldValidation(inp, validator);
        }

        const masker = inp.getAttribute('data-mask');

        if(masker != null && masker.length > 0){
            new FieldMasker(inp, masker);
        }

        const formatter = inp.getAttribute('data-format');

        if(formatter != null && formatter.length > 0){
            new FieldFormatter(inp, formatter);
        }

        if (inp.value && inp.value !== '') {
            inp.classList.add('focused')
        }
    };

    const setupInputValidation = function (input) {
        if (input._validationListenersAdded || input.id === 'smsform-code') {
            // Слушатели уже назначены, ничего не делаем
            return;
        }

        const validateInput = input.id === 'applicationform-passport_department_code' ?
            () => {
                const isValid = input.checkValidity();
                input.classList.toggle('is-invalid', !isValid);
            } :
            () => {
                const isValid = input.checkValidity();
                input.classList.toggle('is-valid', isValid);
                input.classList.toggle('is-invalid', !isValid);
            };

        function removeValidationClasses() {
            input.classList.remove('is-valid', 'is-invalid');
        }

        input.addEventListener('blur', validateInput);
        input.addEventListener('input', removeValidationClasses);

        // Помечаем, что слушатели были назначены
        input._validationListenersAdded = true;
    }

    const initAutocomplete = function (autocompleteContainer) {

        try {
            const type = autocompleteContainer.dataset.autocomplete_type;
            const input = autocompleteContainer.querySelector('input')

            let cancelTokenSource = null;
            if (input) {

                input.addEventListener('insert', function (ev) {
                    autocompleteContainer.style['z-index'] = 6
                    let targ = autocompleteContainer.querySelectorAll('.input_container--expandable-content');
                    if (targ.length) {
                        targ.forEach(el => el.remove())
                        //targ.remove();
                    }

                    input.classList.toggle('is-valid', true);
                    input.classList.toggle('is-invalid', false);
                    input.setCustomValidity("");
                })

                input.addEventListener('focus', function (ev) {
                    let targ = document.querySelectorAll('.input_container--expandable-content');
                    if (targ.length) {
                        targ.forEach(el => el.remove())
                        //targ.remove();
                    }
                })
                input.addEventListener('focusout', function (ev) {
                    autocompleteContainer.style['z-index'] = 6
                })
                input.addEventListener('keyup', async function (ev) {

                    try {
                        // TODO сделать выбор стрелочкой
                        /*if (ev.code === 'ArrowUp' || ev.code === 'ArrowDown' || ev.code === 'Enter') {
                            ev.preventDefault();

                            let currentSelected = null;
                            autocompleteContainer.querySelectorAll('span.inserted').forEach((el, index) => {
                                console.log(index);
                                console.log(el);
                                console.log(el.classList);
                            })

                            return false;
                        }*/

                        input.style['z-index'] = 10
                        if (input.value.trim().length < 3) {
                            return;
                        }




                        if (cancelTokenSource !== null) {
                            cancelTokenSource.cancel();
                        }
                        const url = `/autocomplete/${type}/${encodeURI(input.value.trim())}${input.dataset.parent ? '/'+input.dataset.parent : ''}`

                        cancelTokenSource = axios.CancelToken.source();
                        let currentRequest = await axios.get(url,{
                            cancelToken: cancelTokenSource.token
                        })

                        if (currentRequest.status === 200) {
                            let targ = autocompleteContainer.querySelectorAll('.input_container--expandable-content');
                            targ.forEach(el => el.remove())



                            let html = ``;
                            currentRequest.data.forEach(el => {
                                html += `<span class="<!--focused--> inserted"><button type="button" class="input_container--expandable-insert" data-autocomplete_value='${JSON.stringify(el)}'>${el.value}</button> </span>\n`
                            })
                            if (currentRequest.data.length) {
                                html = `<span style="z-index: 8" class="input_container--expandable-content">${html}</span>`;

                                autocompleteContainer.insertAdjacentHTML('beforeend', html)
                                autocompleteContainer.style['z-index'] = 9
                            }

                        }

                        //cancelTokenSource = null;
                    } catch (e) {
                        //console.log(e)
                    }


                })
            }


        } catch (e) {
            console.log(e);
        }
    }

    window.reInitFormField = initFld;
    window.reInitInputValidation = setupInputValidation;
    window.reInitAutocomplete = initAutocomplete;

    document.querySelectorAll('input, textarea, select').forEach(initFld);
    document.querySelectorAll('input').forEach(setupInputValidation);
    document.querySelectorAll('.autocomplete').forEach(initAutocomplete);

    document.querySelectorAll('[data-validation-unlock]').forEach(form => {
        let unlockTarg = document.getElementById(form.getAttribute('data-validation-unlock'));

        form.addEventListener('input', (e) => {
            let allFields = form.querySelectorAll('input,textarea,select');
            let allValid = true;

            for (let inp of allFields) {
                if (!inp.checkValidity()) {
                    allValid = false;
                    break;
                }
            }

            unlockTarg.disabled = !allValid;
        });
    });

    function transliterate(lang, event) {
        const map = {
            ru: [ "й", "ц", "у", "к", "е", "н", "г", "ш", "щ", "з", "х", "ъ", "ф", "ы", "в", "а", "п", "р", "о", "л", "д", "ж", "э", "я", "ч", "с", "м", "и", "т", "ь", "б", "ю", '"'],
            en: [ "q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "[", "]", "a", "s", "d", "f", "g", "h", "j", "k", "l", ";", "'", "z", "x", "c", "v", "b", "n", "m", ",", ".", '@' ],

            ruUp: [ "Й", "Ц", "У", "К", "Е", "Н", "Г", "Ш", "Щ", "З", "Х", "Ъ", "Ф", "Ы", "В", "А", "П", "Р", "О", "Л", "Д", "Ж", "Э", "Я", "Ч", "С", "М", "И", "Т", "Ь", "Б", "Ю" ],
            enUp: [ "Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "{", "}", "A", "S", "D", "F", "G", "H", "J", "K", "L", ":", '"', "Z", "X", "C", "V", "B", "N", "M", "<", ">" ],
        };

        if (lang === 'en') {
            if (map.ru.indexOf(event.key) !== -1) {
                event.preventDefault();
                let index = map.ru.indexOf(event.key);
                event.target.value += map.en[index];
            }
            if (map.ruUp.indexOf(event.key) !== -1) {
                event.preventDefault();
                let index = map.ruUp.indexOf(event.key);
                event.target.value += map.enUp[index];
            }
        }
        if (lang === 'ru') {
            if (map.en.indexOf(event.key) !== -1) {
                event.preventDefault();
                let index = map.en.indexOf(event.key);
                event.target.value += map.ru[index];
            }
            if (map.enUp.indexOf(event.key) !== -1) {
                event.preventDefault();
                let index = map.enUp.indexOf(event.key);
                event.target.value += map.ruUp[index];
            }
        }
    }

    LiveEvent.on('keypress', 'input[lang=ru]', (e, targ) => {
        transliterate('ru', e)
    })
    LiveEvent.on('keypress', 'input[lang=en]', (e, targ) => {
        transliterate('en', e)
    })

    LiveEvent.on('click', '.input_container--switch', (e, targ) => {
        const input = targ.parentElement.querySelector('input');

        if(input){
            input.type = input.type === 'password' ? 'text' : 'password';
        }
    }).on('click', '.input_container--expandable-insert', (e, targ) => {
        const input = targ.closest('.input_container--expandable').querySelector('input,select,textarea');

        if(input){
            input.value = targ.innerText;
            //input.dispatchEvent(new Event('keyup'))
            let fireData = null;

            try {
                fireData = JSON.parse(targ.dataset.autocomplete_value)
            } catch (e) {

            }
            input.dispatchEvent(new CustomEvent('insert', {
                detail: fireData
            }))
        }
    });

    window.DatePicker = DatePicker;
});